/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from 'react';
import { AuthState, User } from '../../@types/authContext';

const authContext = createContext({
    message: { category: '', mssg: '' },
    logged: false,
    token: '',
    user: { id: '', role: '', enabled: false, name: '', surname: '', email: '' },
    loading: false,
    registerUser: (userData: User) => {},
    googleAuth: (googleCode: string) => {},
    startSession: (userData: User) => {},
    userlogged: () => {},
    closeSession: () => {},
} as AuthState);

export default authContext;
